// Organisation verification API client — pre-purchase anti-fraud gate.
// Independent of hotel activation (which happens on iPads AFTER a paid
// purchase). This flow is: applicant → verify email → get 6-digit code →
// enter code → receive verify_token → include verify_token in pending-order.

import axios from "axios";
import { API } from "../constants";

export async function startVerification(orgName, email, sector, marketingConsent = false) {
  const r = await axios.post(`${API}/verify/start`, {
    org_name: orgName,
    email,
    sector,
    marketing_consent: !!marketingConsent,
  });
  return r.data; // {verify_id, status: "code_sent"|"manual_review_required"}
}

export async function confirmVerificationCode(verify_id, code) {
  const r = await axios.post(`${API}/verify/confirm`, { verify_id, code });
  return r.data.verify_token;
}

export async function requestManualReview(verify_id) {
  const r = await axios.post(`${API}/verify/request-manual`, { verify_id });
  return r.data;
}

export async function getVerifyStatus(verify_id) {
  const r = await axios.get(`${API}/verify/status/${verify_id}`);
  return r.data;
}
